import { MessageModalLayout, ModalProps, Text } from '@wix/design-system';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { CollectionModal } from '../CollectionModal';
import { ConditionalModalState } from '@wix/bex-core';
import { DeleteModalProps } from '../DeleteModal';

export interface CollectionActionModalProps extends Partial<DeleteModalProps> {
  state: ConditionalModalState<unknown>;
  onAfterClose?: ModalProps['onAfterClose'];
}

function _CollectionActionModal({
  state,
  content,
  onAfterClose,
  primaryButtonOnClick,
  secondaryButtonOnClick,
  onCloseButtonClick,
  ...rest
}: CollectionActionModalProps) {
  const { modal } = state;

  return (
    <CollectionModal
      state={modal}
      onAfterClose={() => {
        state.afterClose();
        onAfterClose?.();
      }}
    >
      <MessageModalLayout
        dataHook="collection-action-modal"
        {...rest}
        onCloseButtonClick={(e) => {
          modal.close();
          onCloseButtonClick?.(e);
        }}
        primaryButtonOnClick={() => {
          modal.confirm();
          primaryButtonOnClick?.();
        }}
        secondaryButtonOnClick={() => {
          modal.decline();
          secondaryButtonOnClick?.();
        }}
        content={
          typeof content === 'string' ? (
            <Text dataHook="action-modal-content">{content}</Text>
          ) : (
            content
          )
        }
      />
    </CollectionModal>
  );
}

export const CollectionActionModal = observer(_CollectionActionModal);
